import PhaseSix from "components/Rater/CompleteSelfServey/SurveyPhase/PhaseSix"
import React from "react"

const PhaseSixPage = () => {
    return (
        <React.Fragment>
            <PhaseSix />
        </React.Fragment>
        
    )
}
export default PhaseSixPage
